import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { IBreadCrumb } from './breadcrumb';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { DataService } from 'src/app/services/data/data.service';
import { Subscription } from 'rxjs';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.sass'],
})
export class BreadcrumbComponent implements OnInit {
  public breadcrumbs: IBreadCrumb[];
  isShow;
  currLoc;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dataService: DataService,
    private locationStore: LocationStoreService
  ) {
    this.locationStore.currLocation$.subscribe((res) => {
      if (res.id) {
        this.currLoc = res;
        this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
      } else {
        this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
      }
    });
  }

  ngOnInit(): void {
    this.locationStore.currLocation$.subscribe((res) => {
      if (res.id) {
        this.currLoc = res;
        this.router.events
          .pipe(
            filter((event: Event) => event instanceof NavigationEnd),
            distinctUntilChanged()
          )
          .subscribe(() => {
            this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
          });
      } else {
        this.router.events
          .pipe(
            filter((event: Event) => event instanceof NavigationEnd),
            distinctUntilChanged()
          )
          .subscribe(() => {
            this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
          });
      }
    });
  }

  buildBreadCrumb(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: IBreadCrumb[] = []
  ): IBreadCrumb[] {
    //If no routeConfig is avalailable we are on the root path
    let label =
      route.routeConfig && route.routeConfig.data
        ? route.routeConfig.data.breadcrumb
        : '';
    let icon =
      route.routeConfig && route.routeConfig.data
        ? route.routeConfig.data.icon
        : 'icon-home';
    let path =
      route.routeConfig && route.routeConfig.data ? route.routeConfig.path : '';

    // If the route is dynamic route such as ':id', remove it
    const lastRoutePart = path.split('/').pop();
    const isDynamicRoute = lastRoutePart.startsWith(':');
    if (isDynamicRoute && !!route.snapshot && label.length === 0) {
      const paramName = lastRoutePart.split(':')[1];
      path = path.includes('projects/')
        ? this.currLoc
          ? this.currLoc.parent
            ? path.replace(lastRoutePart, this.currLoc.parent.id)
            : path.replace(lastRoutePart, route.snapshot.params[paramName])
          : path.replace(lastRoutePart, route.snapshot.params[paramName])
        : path.replace(lastRoutePart, route.snapshot.params[paramName]);
      label = path.includes('projects/')
        ? this.currLoc
          ? this.currLoc.parent
            ? this.currLoc.parent.name
            : this.currLoc.name
          : route.snapshot.params[paramName]
        : route.snapshot.params[paramName];
    }

    //In the routeConfig the complete path is not available,
    //so we rebuild it each time
    const nextUrl = path ? `${url}/${path}` : url;

    const breadcrumb: IBreadCrumb = {
      label,
      url: nextUrl,
      icon,
    };
    // Only adding route with non-empty label
    const newBreadcrumbs = breadcrumb.label
      ? [...breadcrumbs, breadcrumb]
      : [...breadcrumbs];
    if (route.firstChild) {
      //If we are not on our current path yet,
      //there will be more children to look after, to build our breadcumb
      return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
    }
    return newBreadcrumbs;
  }

  toggleShow() {
    this.isShow = !this.isShow;
  }
}
